import { render, staticRenderFns } from "./TCGhostSchedule.vue?vue&type=template&id=ad20bde8&"
import script from "./TCGhostSchedule.vue?vue&type=script&lang=js&"
export * from "./TCGhostSchedule.vue?vue&type=script&lang=js&"
import style0 from "./TCGhostSchedule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports